<div class="row pb-4 recommended-label">
    <div class="col-lg-4 d-flex flex-column" id="base">
        <div class="card mb-4 shadow-sm flex-fill">
            <div class="card-body">
                <!-- <span class="subtitle">Your Current plan</span> -->
                <h3 class="card-title">Base</h3>
                <div class="card-text">
                    <ul class="tick fa-ul">
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Base Price (10 makers)</li>
                        <!-- <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            A maker is a person within your organization who is a owner of a Flow or Power App</li> -->
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            US$200 / month or<br> US$2000 / year</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Monitors creation and modification of Power Apps</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Monitors creation and modification of Power Automate (Flows)</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Monitors flow runs, retains run metadata beyond 28 days</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Monitors creation and modification of environments</li>
                        <!-- <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Monitor for up to 10 maker's Power Apps and Power Automate (Flows)</li> -->
                    </ul>
                </div>
            </div>                            
        </div>
    </div>
    <div class="col-lg-4 d-flex flex-column" id="grow">
        <div class="card mb-4 shadow-sm flex-fill">
            <div class="card-body">
                <!-- <span class="subtitle">Your Current plan</span> -->
                <h3 class="card-title">Growth</h3>
                <div class="card-text">
                    <ul class="tick fa-ul">
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Between 10 ~ 100 makers</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Base + US$10 per additional user per month</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Everything in base<br>
                            But at this size you would focus on deeper governance...
                        </li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Summary reports of new Power Apps, Flows and Makers</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Automate webhooks to listen to create your own custom emails or process</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Create accept or block list of domains, URLs</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Understand the impact of your DLP policies</li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4 d-flex flex-column" id="enterprise">
        <div class="card mb-4 shadow-sm flex-fill">
            <div class="card-body">
                <!-- <span class="subtitle">Your Current plan</span> -->
                <h3 class="card-title">Enterprise</h3>
                <div class="card-text">
                    <ul class="tick fa-ul">
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Beyond 100 makers</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            Custom pricing</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            At scale, our per-maker costs starts to get cheaper</li>
                        <li><span class="fa-li"><fa-icon icon="check-circle" class="text-primary"></fa-icon></span>
                            We can accomodate other specialized customizations - please have a chat with us</li>
                    </ul>
                </div>
            </div>                            
        </div>
    </div>
</div>
